import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Global } from "../../classes/global";
import { MerchantService } from "../../services/merchant/merchant.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-tiktok-app-info',
  templateUrl: './tiktok-app-info.component.html',
  styleUrls: ['./tiktok-app-info.component.scss']
})
export class TiktokAppInfoComponent implements OnInit {
  @ViewChild('tiktokAppInfoModal', { static: false }) private tiktokAppInfoModal;

  appInfos: any[] = [];

  constructor(
    private modalService: NgbModal,
    private global: Global,
    private merchantService: MerchantService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
  }

  openModal() {
    this.global.pageLoading = true;
    this.merchantService.getTiktokAppInfos()
      .subscribe(
        data => {
          this.global.pageLoading = false;
          this.appInfos = data;
          this.modalService.open(this.tiktokAppInfoModal, { windowClass: "lModal" });
        },
        error => {
          this.global.pageLoading = false;
          console.error('Error loading TikTok app info:', error);
        }
      );
  }
  

  onCoppied() {
    this.toastr.success('Copied!');
  }
} 
